(function () {
  'use strict';
  angular.module('vcdms.vcfile')
    .component('fileupload', {
      restrict: 'E',
      bindings: {
        parentsave: '&',
        label: '@?',
        color: '@?',
        consultid: '<?',
        examid: '<?',
        clientid: '<?'
      },
      template: `
          <input type="file" name="{{vm.uuid}}" id="{{vm.uuid}}" class="inputfile" />
          <label class="btn btn-{{vm.color || 'primary'}}" for="{{vm.uuid}}" uib-tooltip="Datei upload">
            <i class="fa fa-upload" ></i> {{vm.label || '' }}
            <span ng-show="vm.saved"><i class="fa fa-check text-success"></i></span>
            <span ng-show="vm.error"><i class="fa fa-warning text-danger"></i></span>
          </label>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Fileupload', '$element', '$timeout',
        function ($log, $http, Rlog, Fileupload, $element, $timeout) {
          let vm = this;
          vm.upload = upload;

          // create unique identifiers for fileupload input ids
          vm.uuid = guid();

          // init
          vm.$onInit = function () {
            // handle optional parameters

            if (angular.isUndefined(vm.clientid)) {
              vm.clientid = '';
              vm.patientid = '';
            }
            if (angular.isUndefined(vm.consultid)) {
              vm.consultid = '';
            }
            if (angular.isUndefined(vm.examid)) {
              vm.examid = '';
            }
            $element.bind('change', function (e) {
              vm.ufile = (e.srcElement || e.target).files[0];
              vm.upload();
            });

          };


          // vm.consultid, etc might be late propagating
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.consultid)) {
                vm.consultid = changes.consultid.currentValue;
              }
              if (angular.isDefined(changes.clientid)) {
                vm.clientid = changes.clientid.currentValue;
              }
              if (angular.isDefined(changes.examid)) {
                vm.examid = changes.examid.currentValue;
              }
            }
          };

          function upload() {
            Fileupload.uploadFileToUrl(vm.ufile, 'fileupload', vm.consultid, vm.clientid, vm.examid)
              .then(function (res) {
                $log.debug('Fileupload successful: ', res);
                vm.saved = true;
                vm.parentsave({filedata: res.data});
                $timeout(function () {
                  delete vm.saved;
                }, 5000);
              }, function (res) {
                $log.debug('Fileupload error');
                vm.error = true;
                $timeout(function () {
                  delete vm.error;
                }, 5000);
                return res;
              });
          }

          function guid() {
            function s4() {
              return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
            }

            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
              s4() + '-' + s4() + s4() + s4();
          }

        }] // controller
    }); // component


  // klammerfriedhof
}());
